import { useState, useCallback } from 'react';

const MAX_PINS = 5;

export function usePinnedPlayers(
  pinnedPlayers: string[],
  onPinnedPlayersChange?: (players: string[]) => void
) {
  const [pinToast, setPinToast] = useState(false);

  const togglePin = useCallback((playerName: string) => {
    if (!onPinnedPlayersChange) return;
    if (pinnedPlayers.includes(playerName)) {
      onPinnedPlayersChange(pinnedPlayers.filter(n => n !== playerName));
    } else {
      if (pinnedPlayers.length >= MAX_PINS) {
        setPinToast(true);
        setTimeout(() => setPinToast(false), 2000);
        return;
      }
      onPinnedPlayersChange([...pinnedPlayers, playerName]);
    }
  }, [pinnedPlayers, onPinnedPlayersChange]);

  const unpinPlayer = useCallback((playerName: string) => {
    if (!onPinnedPlayersChange) return;
    onPinnedPlayersChange(pinnedPlayers.filter(n => n !== playerName));
  }, [pinnedPlayers, onPinnedPlayersChange]);

  return { togglePin, unpinPlayer, pinToast, MAX_PINS };
}
